import React, { useState } from 'react'
import { Header, Modal, Button, Icon, Item, Grid } from 'semantic-ui-react'
import ShowMoreText from "react-show-more-text";
import { useTranslation } from "react-i18next";

import "./AboutAccommodation.css"

const AboutAccommodation = () => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false)
    return (<>
        <Header as='h3'>{t("property:AboutThisPlace")}</Header>
        <ShowMoreText
            lines={2}
            more={t("property:More")}
            less={t("property:Less")}
            className="content-css"
            anchorClass="my-anchor-css-class ui button d-block basic w-max m-1-t blue text-blue  text-right"
            expanded={false}
            truncatedEndingComponent={""}
        >
            <p>این منزل در یک آپارتمان ۴ طبقه مجهز به آسانسور قرار دارد.</p>
            <p>این آپارتمان تمیز و مرتب در فاصله زمانی حدود ۵ دقیقه ای با ماشین، از دریا واقع شده و همچنین همین فاصله را از مراکز خرید دارد، از این رو دسترسی به امکانات شهری و مراکز خرید و مراکز تفریحی برای مهمانان ساده خواهد بود. فروشگاه مواد غذایی پایین آپارتمان قرار دارد.</p>
            <p>لازم به ذکر است که مهمانان از تخفیف کرایه خودروهای لوکس هم برخوردار خواهند بود </p>
            <p>مجموعاً 8 واحد از این اقامتگاه در این مجموعه وجود دارد که کاملا مشابه هستند و فقط رنگ مبلمان واحد ها با یکدیگر متفاوت هستند ممکن است در زمان تحویل یک واحد دیگر در همین ساختمان با رنگ مبلمان متفاوت در طبقه دیگر به شما تحویل داده شود.</p>
        </ShowMoreText>
        <Modal
            size="small"
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            open={open}
            trigger={<Button size="big" className="m-1-t m-1-b p-1-t p-1-b p-0 bg-transparent text-blue" >{t("property:MoreInformationAboutThisAccommodation")}
                <Icon name="chevron right" /></Button>}>
            <Modal.Header>{t("property:MoreInformationAboutThisAccommodation")}</Modal.Header>
            <Modal.Content scrolling>
                <Modal.Description>
                    <Header>{t("property:AboutThisPlace")}</Header>
                    <ShowMoreText
                        lines={2}
                        more={t("property:More")}
                        less={t("property:Less")}
                        className="content-css"
                        anchorClass="my-anchor-css-class ui button d-block basic w-max m-1-t blue text-blue  text-right"
                        expanded={false}
                        truncatedEndingComponent={""}
                    >
                        <p>این منزل در یک آپارتمان ۴ طبقه مجهز به آسانسور قرار دارد.</p>
                        <p>این آپارتمان تمیز و مرتب در فاصله زمانی حدود ۵ دقیقه ای با ماشین، از دریا واقع شده و همچنین همین فاصله را از مراکز خرید دارد، از این رو دسترسی به امکانات شهری و مراکز خرید و مراکز تفریحی برای مهمانان ساده خواهد بود. فروشگاه مواد غذایی پایین آپارتمان قرار دارد.</p>
                        <p>لازم به ذکر است که مهمانان از تخفیف کرایه خودروهای لوکس هم برخوردار خواهند بود </p>
                        <p>مجموعاً 8 واحد از این اقامتگاه در این مجموعه وجود دارد که کاملا مشابه هستند و فقط رنگ مبلمان واحد ها با یکدیگر متفاوت هستند ممکن است در زمان تحویل یک واحد دیگر در همین ساختمان با رنگ مبلمان متفاوت در طبقه دیگر به شما تحویل داده شود.</p>
                    </ShowMoreText>
                    <Header>{t("property:BuildingInformation")}</Header>
                    <Grid columns='equal'>
                        <Grid.Row className="p-1-t">
                            <Grid.Column>
                                <p>{t("property:StructureType")} : <span>هم‌سطح</span></p>
                            </Grid.Column>
                            <Grid.Column>
                                <p>{t("property:SizeOfLand")} : <span> 360</span> {t("property:Meter")}</p>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row className="p-05-t">
                            <Grid.Column>
                                <p>{t("property:NumberOfFloors")} : <span>4</span> {t("property:Floor")}</p>
                            </Grid.Column>
                            <Grid.Column>
                                <p>{t("property:BuildingArea")} : <span>95</span> {t("property:Meter")}</p>

                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row className="p-05-t">
                            <Grid.Column>
                                <p>{t("property:ClassOfThisUnit")} : <span>طبقه ی ۳</span></p>
                            </Grid.Column>
                            <Grid.Column>
                                <p>{t("property:YearOfConstruction")} : <span>۱۴۰۰</span></p>

                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row className="p-05-t">
                            <Grid.Column>
                                <p>{t("property:NumberOfUnitsInEachFloor")} : <span>۲</span></p>
                            </Grid.Column>
                            <Grid.Column>
                                <p>{t("property:NumberOfStairs")} : <span>کمتر از ۵</span></p>

                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Description>
            </Modal.Content>
        </Modal>
    </>
    )
}
export default AboutAccommodation